export default __webpack_public_path__ + "static/media/information--cycling-two-abreast-permitted--g1.f7b5c1af.png";